const t = (n) => {
  if (n) {
    const r = {};
    for (const o in n)
      r[`data-a-${o}`] = n[o];
    return r;
  }
  return null;
}, a = (n) => t(n);
export {
  t as a,
  a as e
};
//# sourceMappingURL=useDataAnalytics.aoO050RE.js.map
